module.exports = __webpack_public_path__ + "images/730b456d20ded9f910ce6c879bf9c804-luxury_xpo.png";